import { useEffect, useState } from "react";
import { Wrench } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/admin";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

function MaintenanceScreen() {
  return (
    <div data-testid="maintenance-screen" className="min-h-screen grid place-items-center bg-black text-white px-6 text-center relative overflow-hidden">
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-72 h-72 sm:w-[520px] sm:h-[520px] rounded-full bg-[#ff4500]/20 blur-3xl pointer-events-none" aria-hidden />
      <div className="relative">
        <img src="/logo.jpeg" alt="RECARGAS al Instante" className="w-36 h-36 sm:w-44 sm:h-44 rounded-full mx-auto border-2 border-[#ff4500] shadow-[0_0_60px_rgba(255,69,0,0.45)]" />
        <div className="mt-6 inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#ff4500]/10 border border-[#ff4500]/40 text-[#ff4500] text-xs tracking-widest">
          <Wrench className="w-3.5 h-3.5" /> MANTENIMIENTO
        </div>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl tracking-wider">Volvemos en un rato</h1>
        <p className="mt-3 text-neutral-400 text-sm sm:text-base max-w-md mx-auto">
          Estamos mejorando <span className="text-white">RECARGAS al Instante</span>. Mientras tanto, escribinos por WhatsApp.
        </p>
        <div className="mt-6 flex flex-col sm:flex-row gap-2 justify-center">
          <a href="https://wa.me/543821452181" target="_blank" rel="noopener noreferrer" data-testid="maintenance-wa-1" className="btn-primary px-5 py-2.5 rounded-md text-sm">WhatsApp +54 3821 452181</a>
          <a href="https://wa.me/543821450522" target="_blank" rel="noopener noreferrer" data-testid="maintenance-wa-2" className="px-5 py-2.5 rounded-md text-sm border border-white/15 hover:bg-white/5">WhatsApp +54 3821 450522</a>
        </div>
        <button onClick={startGoogleLogin} data-testid="maintenance-admin-login" className="mt-8 text-[11px] text-neutral-600 hover:text-neutral-400">Acceso administrador</button>
      </div>
    </div>
  );
}

export default function MaintenanceGate({ children }) {
  const { user, loading } = useAuth();
  const [maintenance, setMaintenance] = useState(false);

  useEffect(() => {
    api.get("/site/status").then(({ data }) => setMaintenance(!!data.maintenance)).catch(() => {});
  }, []);

  if (maintenance && !loading && !user?.is_admin) return <MaintenanceScreen />;
  return children;
}
